import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from '../../@store/_common/number-type-helpers';
import { NO_VALUE } from '../../shared/pipes';

@Pipe({
  name: 'toFixed',
})
/**
 * this pipe accept string, but it is not wise to pass localized number ( simple parseFloat inside )
 */
export class ToFixedPipe implements PipeTransform {
  constructor() {}

  transform(val: number | string, toFixed?: number): string {
    toFixed = toFixed ?? 2;

    if (val === null || val === undefined) {
      return NO_VALUE;
    }

    if (isNumber(val)) {
      if (typeof val === 'number') {
        return val.toFixed(toFixed);
      }
      if (typeof val === 'string') {
        return parseFloat(val).toFixed(toFixed);
      }
    }

    return NO_VALUE;
  }
}
